import { X } from "lucide-react";

type Props = {
  onPause: () => void;
  testIdRoot?: string;
  label?: string;
};

/**
 * Pause is the default close behavior for every mission in Orkexra.
 * Clicking this button never cancels or completes — it only persists
 * memory and closes the surface. Cancellation ships in 37.5.
 */
export function MissionPauseButton({
  onPause,
  testIdRoot = "mission-shell",
  label = "Pause",
}: Props) {
  return (
    <button
      type="button"
      onClick={onPause}
      className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-medium text-white/80 hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400 transition"
      data-testid={`${testIdRoot}-pause`}
      aria-label={`${label} mission and return later`}
    >
      <X className="h-3.5 w-3.5" aria-hidden />
      {label}
    </button>
  );
}
